import { useEffect, useState } from "react";
import { fetchClients } from "../api";
import { Link } from "react-router-dom";

const featuredProducts = [
  {
    name: "Pharmaceutical Division",
    image: "/assets/pharma.webp",
    category: "pharmaceutical ",
  },
  {
    name: "Industrial Division",
    image: "/assets/indust.jpg",
    category: "industrial ",
  },
  {
    name: "Food Division",
    image: "/assets/products/food/Packaging/Cobot Palletisers.png",
    category: "food",
  },
];

const heroImages = [
  "/assets/pharma2.webp",
  "/assets/1.webp",
  "/assets/2.jpg",
  "/assets/4.webp",
  "/assets/5.webp",
  "/assets/download (5).jfif"
];

function HomePage() {
  const [clients, setClients] = useState([]);
  const [logoIndexes, setLogoIndexes] = useState([]);
  const [heroIndex, setHeroIndex] = useState(0);

  useEffect(() => {
    fetchClients().then((data) => {
      setClients(data);
      if (data.length > 3) {
        let shuffledIndexes = data.map((_, i) => i).sort(() => Math.random() - 0.5);
        setLogoIndexes(shuffledIndexes.slice(0, 5));
      }
    });
  }, []);

  useEffect(() => {
    if (clients.length > 4) {
      const interval = setInterval(() => {
        setLogoIndexes((prevIndexes) => {
          let availableIndexes = clients.map((_, i) => i).filter((index) => !prevIndexes.includes(index));
          for (let i = availableIndexes.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [availableIndexes[i], availableIndexes[j]] = [availableIndexes[j], availableIndexes[i]];
          }
          return availableIndexes.slice(0, 5);
        });
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [clients]);

  const nextSlide = () => setHeroIndex((prev) => (prev + 1) % heroImages.length);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-container">
      {/* Hero Section */}
      <div
        className="hero fade"
        style={{ backgroundImage: `url(${heroImages[heroIndex]})` }}
      >
        <div className="text-box">
          <h1>Welcome to Shehab Engineering</h1>
          <p>
            Your Trusted Partner in Industrial Machinery and Solutions.<br />
            At Shehab Engineering, we proudly represent leading multinational and international manufacturers, delivering cutting-edge solutions
          </p>
        </div>
      </div>

      {/* Featured Products Section */}
      <section className="section">
        <h2>INDUSTRIES WE SERVE </h2>
        <div className="product-grid">
          {featuredProducts.map((product, i) => (
            <Link
              key={i}
              to={`/products?category=${product.category}`.toUpperCase()}
              className="product-card-link"
            >
              <div className="product-card">
                <img src={product.image} alt={product.name} />
                <h3>{product.name}</h3>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Clients */}
      <section className="section">
        <h2>BRANDS WE REPRESENT</h2>
        <div className="logo-container">
          {clients.length > 0 &&
            logoIndexes.map((index) => (
              <div key={index} className="hero-image fade">
                <img
                  src={clients[index]?.logo}
                  alt="Client Logo"
                  className="fixed-logo-size client-logo"
                />
              </div>
            ))}
        </div>
      </section>

      {/* Careers */}
      <section className="section">
        <h2>CAREERS</h2>
        <p>Join Our Team</p>
        <a href="/careers" className="careers-btn">
          View Open Positions
        </a>
      </section>
    </div>
  );
}

// Injected CSS
const homeStyles = `
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.home-container {
  width: 100%;
  font-family: Arial, sans-serif;
  background: #f9f9f9;
  color: #000;
  padding-top: 100px;
  padding-bottom: 40px;
  min-height: 100vh;
  text-align: center;
}

.hero {
  position: relative;
  width: 100%;
  height: 500px;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 20px;
  color: white;
  overflow: hidden;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  transition: background-image 1s ease-in-out;
}

.hero.fade {
  animation: fadeIn 1s ease-in-out;
}

.hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 0;
}

.hero .text-box {
  position: relative;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.7);
  color: black;
  padding: 20px 30px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  max-width: 1000px;
  margin: 20px auto;  /* Auto horizontal margins */
  text-align: left;
}


.hero .text-box h1 {
  font-size: 2rem;
  margin-bottom: 10px;
}

.hero .text-box p {
  font-size: 1rem;
  line-height: 1.4;
}

.section {
  margin-top: 40px;
}

.logo-container {
  width: 80%;
  margin: 30px auto 0 auto;
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
  padding: 30px;
  background: rgb(243, 233, 233);
  border-radius: 24px;
  box-shadow: inset 0 1px 3px rgba(0,0,0,0.05);
}

.hero-image.fade {
  animation: fadeIn 1s ease-in-out;
}

.hero-image {
  width: 170px;
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 15px;
  padding: 10px;
  transition: transform 0.5s ease-in-out;
}

.client-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.product-grid {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.product-card-link {
  text-decoration: none;
  color: inherit;
}

.product-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0px 2px 10px rgba(0,0,0,0.1);
  width: 220px;
  padding: 20px;
  text-align: center;
  transition: transform 0.2s ease;
}

.product-card:hover {
  transform: scale(1.03);
}

.product-card img {
  width: 100%;
  height: 150px;
  object-fit: contain;
  margin-bottom: 10px;
}

.careers-btn {
  display: inline-block;
  background-color: #F48039;
  color: black;
  padding: 12px 24px;
  border-radius: 1px;
  margin-top: 10px;
  text-decoration: none;
}
`;

const homeStyleSheet = document.createElement("style");
homeStyleSheet.type = "text/css";
homeStyleSheet.innerText = homeStyles;
document.head.appendChild(homeStyleSheet);

export default HomePage;
